import React from 'react';
import { Helmet } from 'react-helmet-async';

const VideoPage = () => {
  const hiddenStyle = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: '0'
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="index, noindex, noarchive" />
      </Helmet>

      <div className="video-container">
        <h1 style={hiddenStyle}>Rembrand Pardo's Website Introduction Video</h1>
        <p style={hiddenStyle}>Designed By Pardo</p>
        <video 
          src="/intro.mp4"
          autoPlay
          muted
          controls
          playsInline
          poster="/intro-thumbnail.jpg"
          className="intro-video"
        >
          <source src="/intro.mp4" type="video/mp4" />
          <source src="/intro.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  );
};

export default VideoPage;
